import { useProjectsSimpleQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useInvoiceStore } from "../store";

export const useFetchProjectsSimpleData = () => {
  const store = useInvoiceStore();

  useProjectsSimpleQuery({
    variables: {
      clientId: store.form.client_id.value || undefined,
      orIdIn: store.form.project_ids.value,
      withProBono: false,
    },
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      if (data) {
        store.setProjectsSimple(data);
      }
    },
    ...onError(),
  });
};
